export const LICENSE_MANAGEMENT = 'licenseManagement';
